import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/useAuth';
import AILoginPage from '@/components/ui/ai-login';
import { createComponentLogger } from '@/utils/logger';
import { getRedirectDestination, storeOAuthRedirect } from '@/utils/authRedirect';

const log = createComponentLogger('Login', 'authentication');

export const Login: React.FC = () => {
  const { signIn, signInWithGoogle, user } = useAuth();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  // Get intended destination for OAuth storage (uses centralized validation)
  const intendedDestination = getRedirectDestination({
    locationState: location.state,
    searchParams: new URLSearchParams(location.search)
  });

  // Note: Navigation after login is handled by HomeRoute, not here.
  // This effect is kept for logging/debugging purposes only.
  useEffect(() => {
    if (user) {
      log.debug('User authenticated, HomeRoute will handle navigation to:', intendedDestination);
    }
  }, [user, intendedDestination]);

  const handleLogin = async (credentials: { email: string; password: string }) => {
    if (isLoading) {
return;
} // Prevent double-clicks

    setIsLoading(true);
    const { error } = await signIn(credentials.email, credentials.password);

    if (error) {
      log.error('Login failed', { email: credentials.email }, error);
      setIsLoading(false);
      throw error;
    }
    // Navigation handled by HomeRoute when user state updates
  };

  const handleGoogleLogin = async () => {
    if (isLoading) {
return;
} // Prevent double-clicks

    // Store redirect before OAuth (leaves the app and returns to OAuthCallback)
    storeOAuthRedirect(intendedDestination);

    setIsLoading(true);
    const { error } = await signInWithGoogle();

    if (error) {
      log.error('Google login failed', undefined, error);
      setIsLoading(false);
      throw error;
    }
    // After OAuth, user returns to OAuthCallback which handles navigation
  };

  return (
    <AILoginPage onLogin={handleLogin} onGoogleLogin={handleGoogleLogin} />
  );
};